import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';


import {HttpClient, HttpParams} from '@angular/common/http';
import {ExportResponse} from '../../types/export/export';
import {BaseRestService} from '../common/BaseRestService';
import {map} from 'rxjs/operators';

@Injectable()
export class ExportRestService extends BaseRestService {

  private readonly endPoints;

  constructor(private http: HttpClient) {
    super('');

    this.endPoints = {
      scoutingAroundWorld: this.getEndpoint(['countries/scouting-around-world/export']),
      terminologyWorkbook: this.getEndpoint(['organizations/terminology-workbook/export']),
      contactDetails: this.getEndpoint(['organizations/contact-details/export']),
      card: this.getEndpoint(['consultants/card']),
      'full-card': this.getEndpoint(['consultants/full-card']),
      currentSelection: this.getEndpoint(['organizations/current-selection/export'])
    };

  }

  private static toExportResponse(res): ExportResponse {
    const fileNameRegex = /filename="(.*)"/;

    return {
      filename: res.headers.get('content-disposition').match(fileNameRegex)[1],
      blob: res.body
    };
  }

  export(type, filter): Observable<ExportResponse> {
    return this.http.get(this.endPoints[type], {
      responseType: 'blob',
      observe: 'response',
      params: this.getParams(filter)
    }).pipe(map(ExportRestService.toExportResponse));
  }

  private getParams(filter) {
    let params: HttpParams = new HttpParams();

    Object.keys(filter).forEach(key => {
      if (key === 'officialNso') {
        params = params.set(key, filter.officialNso);
      }
      if (filter[key]) {
        params = params.set(key, filter[key]);
      }
    });
    return params;
  }

  generateCard(type: string, consultantId: number, titleId) {
    const params: HttpParams = new HttpParams()
      .set('consultantId', String(consultantId))
      .set('titleId', String(titleId));
    return this.http.get(this.endPoints[type], {
      responseType: 'blob',
      observe: 'response',
      params
    }).pipe(map(ExportRestService.toExportResponse));
  }

  noop() {
  }
}
